import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import { AnalyticsService, ICollectedAnalyticsData } from '../../analytics.service';
import { AnalyticsBase } from '../../analyticsBase';

class ShopVisitsAnalyticsComponent extends AnalyticsBase {
    public static $inject = ['$scope', '$stateParams', '$filter', 'analyticsService', '$translate'];

    constructor(
        protected $scope: ng.IScope,
        protected $stateParams: StateParams,
        protected $filter: ng.IFilterService,
        protected analiticsService: AnalyticsService,
        protected $translate: angular.translate.ITranslateService
    ) {
        super($scope, $stateParams, $filter, analiticsService, $translate);
    }
    public switchTab(tab: string) {
        this.filter.group = tab;
    }

    protected setFilterExtension() {
        this.filter = angular.extend(this.filter, { group: this.tabs[0] });
    }

    protected getData(id: number, filter: any): angular.IPromise<ICollectedAnalyticsData[]> {
        return this.analiticsService.getStoreVisitsAnalytics(this.id, this.filter);
    }
}

angular.module('naut').component('shopVisitsAnalytics', {
    template: require('./shopVisitsAnalytics.html'),
    controller: ShopVisitsAnalyticsComponent,
    controllerAs: 'vm',
    bindings: {

    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/analytics/components/shopVisitsAnalytics/shopVisitsAnalytics.component.ts